<template>
  <div class="site-container">
    <img class="bg-img" :src="bgImg">

    <div class="service-container">
      <div class="service-item" v-for="(service, index) in fieldList" :key="index">
        <div class="service-name">{{service.title}}</div>
        <div class="service-content">
          <div class="service-icon">
            <img :src="service.coverIcon" alt="">
          </div>
          <div class="service-btn">
            <span class="text" @click="toDetail(service)">点击查看 &gt;</span>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        fieldList: [],
        bgImg: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/cac/field%20service_bg.png?_t=" + Date.now()
      }
    },
    mounted() {
      this.initData()
      this.getFigures()
    },
    methods: {
      initData() {
        this.$store.commit('changeToken', 'PBB+hfqyCn5u/Asp+KqEaro7AhH4z/+bW0+9qxZHTV3GqTTtK0xlBOZ/bJUKrMMzpQGrxvbaa1O+XC9IM1Esf+sq+GwKEVbFVC5oHf4ckhDvF0COJwODWI/otfPxmvDr8/lzo80KxYaPNqn7kEkK/5d3CRmNDUlQBGo9iBXFyJm9IcXhTs3UJ3PSx/3pyao67h18E1SncYIPukUmWlVAsHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=')
      },
      getFigures() {
        const params = {
          exhibitionId: 'b33d8960b7a245cb97146670283ac360',
          appId: '7e46f33c139246069a3c17c9f4847a25',
          languageType: 'cn',
          subjectType: 'VISITOR',
          sourceType: 2
        }
        this.$http.getFigures(params).then(res => {
          console.log(res)
          if (res.code === 1000) {
            const bannerMap = res.data.bannerMap
            this.fieldList = bannerMap.FIGURE_TECHNOLOGY
          }
        })
      },
      toDetail(site) {
        if (site.url) {
          window.location.href = site.url
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .site-container {
    width: 100%;
    .bg-img {
      display: block;
      width: 100%;
    }
    .service-container {
      width: 100%;
      position: absolute;
      top: 27%;
      padding: 0 15px;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
      .service-item {
        width: 100%;
        border-radius: 8px;
        padding: 12px;
        box-sizing: border-box;
        &:nth-child(1) {
          color: #016E5A;
          background: linear-gradient( 45deg, #DBF4EF 0%, #F1FAF4 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(1,110,90,0.2) 0%, rgba(1,110,90,0.05) 100%);
            }
          }
        }
        &:nth-child(2) {
          color: #016E5A;
          background: linear-gradient( 45deg, #DBF4EF 0%, #F1FAF4 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(1,110,90,0.2) 0%, rgba(1,110,90,0.05) 100%);
            }
          }
        }
        &:nth-child(3) {
          color: #0644B5;
          background: linear-gradient( 45deg, #CED8F2 0%, #EEF4F9 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(7,70,185,0.2) 0%, rgba(7,70,185,0.05) 100%);
            }
          }
        }
        &:nth-child(4) {
          color: #0644B5;
          background: linear-gradient( 45deg, #CED8F2 0%, #EEF4F9 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(7,70,185,0.2) 0%, rgba(7,70,185,0.05) 100%);
            }
          }
        }
        &:nth-child(5) {
          color: #0644B5;
          background: linear-gradient( 45deg, #CED8F2 0%, #EEF4F9 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(7,70,185,0.2) 0%, rgba(7,70,185,0.05) 100%);
            }
          }
        }
        &:nth-child(6) {
          color: #0644B5;
          background: linear-gradient( 45deg, #CED8F2 0%, #EEF4F9 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(7,70,185,0.2) 0%, rgba(7,70,185,0.05) 100%);
            }
          }
        }
        &:nth-child(7) {
          color: #E20909;
          background: linear-gradient( 45deg, #FBE1E1 0%, #FEF4F4 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(226,9,9,0.2) 0%, rgba(226,9,9,0.05) 100%);
            }
          }
        }
        &:nth-child(8) {
          color: #E20909;
          background: linear-gradient( 45deg, #FBE1E1 0%, #FEF4F4 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(226,9,9,0.2) 0%, rgba(226,9,9,0.05) 100%);
            }
          }
        }
        &:nth-child(9) {
          color: #E20909;
          background: linear-gradient( 45deg, #FBE1E1 0%, #FEF4F4 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(226,9,9,0.2) 0%, rgba(226,9,9,0.05) 100%);
            }
          }
        }
        &:nth-child(10) {
          color: #E20909;
          background: linear-gradient( 45deg, #FBE1E1 0%, #FEF4F4 100%);
          .service-content {
            .service-btn {
              background: linear-gradient( 45deg, rgba(226,9,9,0.2) 0%, rgba(226,9,9,0.05) 100%);
            }
          }
        }
        .service-name {
          font-weight: 500;
          font-size: 14px;
        }
        .service-content {
          margin-top: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .service-icon {
            width: 25px;
            height: 25px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .service-btn {
            width: 68px;
            height: 14px;
            border-radius: 34px;
            padding: 4px 0;
            font-weight: 400;
            font-size: 10px;
            text-align: center;
          }
        }
      }
    }
    
  }
</style>